import { Text, Heading, Icon, Colors, ButtonGradientPrimary } from '@amelio/ui-library';

import { PrepareMeetingArrowIllustration } from '@/components/Illustrations/Illustration';
import { useAmelioTranslations } from '@/hooks';

interface MeetingPreparationIllustrationProps {
    employeeFirstName: string;
    onPrepareMeetingClick: () => void;
    className?: string;
}

export const MeetingPreparationIllustration = ({
    employeeFirstName,
    onPrepareMeetingClick,
    className = '',
}: MeetingPreparationIllustrationProps) => {
    const { t } = useAmelioTranslations();
    const title = t('managerAssessmentResults.meetingPreparation.title', {
        name: employeeFirstName,
    });
    const titleParts = title.split(employeeFirstName);

    return (
        <div className={`relative flex flex-col justify-center md:mt-25 md:flex-row ${className}`}>
            <div className={'flex flex-1 items-start justify-center text-center'}>
                <Heading
                    level={1}
                    className={
                        'mx-auto mb-5 max-w-md pt-0 text-center text-[24px] sm:text-3xl md:mb-0 md:!pt-[16px] md:!text-[30px]'
                    }
                >
                    {titleParts[0]}
                    {employeeFirstName}
                    {titleParts[1]}
                </Heading>
            </div>

            <PrepareMeetingArrowIllustration
                className={
                    'pointer-events-none absolute top-[5.5rem] left-[19%] z-10 w-[28%] max-md:hidden md:top-[5.75rem] md:left-[21%] md:w-[35%] lg:top-[6rem] lg:left-[17%] lg:w-[34%] xl:top-[6.5rem] xl:left-[21%] xl:w-[32%] 2xl:top-[7rem] 2xl:left-[22%] 2xl:w-[30%]'
                }
            />

            <div className={'mt-5 flex flex-1 justify-start md:mt-0'}>
                <div
                    className={
                        'ml-auto flex flex-col gap-4 rounded-xl border border-purple-200/30 bg-white/50 p-7 backdrop-blur-sm transition-all duration-300 hover:border-purple-300/60 md:p-[24px]'
                    }
                >
                    <Text
                        size={'default'}
                        className={'mb-4 text-gray-700'}
                    >
                        {t('managerAssessmentResults.meetingPreparation.description')}
                    </Text>
                    <ButtonGradientPrimary
                        onClick={onPrepareMeetingClick}
                        leftIcon={
                            <Icon
                                name={'essential-add'}
                                color={Colors.WHITE}
                                className={'!h-[24px] !w-[24px] sm:!h-[28px] sm:!w-[28px]'}
                            />
                        }
                        className={
                            '!h-auto w-full !gap-3.5 !px-[32px] py-[12px] text-[16px] hover:scale-100! sm:!w-fit sm:py-3.5'
                        }
                    >
                        {t('managerAssessmentResults.meetingPreparation.button')}
                    </ButtonGradientPrimary>
                </div>
            </div>
        </div>
    );
};

export default MeetingPreparationIllustration;
